// extracted by mini-css-extract-plugin
export default {"container":"LabelTextInput_container__nM4sV","inputLabel":"LabelTextInput_inputLabel__3WgMK","inputText":"LabelTextInput_inputText__x3dPc"};